import {
    Box
} from "@mui/material";
import Lottie from 'react-lottie';
import DefaultStepIcon from '@mui/material/StepIcon';
import * as BluePulsingCircle from 'assets/lottie/blue_pulsing_circle.json'
import styles from './styles.module.scss';

const AnimatedStepIcon = ({ active, completed, icon, error, isCurrent }) => {
    if (isCurrent && active && !completed && !error) {
        return (
            <Box className={styles.animationWrapper}>
                <Box className={styles.lottieContainer}>
                    <Lottie
                        options={{ loop: true, autoplay: true, animationData: BluePulsingCircle }} />
                    <Box className={styles.lottieChild}>
                       {icon}
                    </Box>
                </Box>
            </Box>
        );
    }

    if (error) return <DefaultStepIcon className={styles.error} icon={icon} />

    return <DefaultStepIcon
                classes={{ completed: styles.completed, active: styles.active }}
                active={active} completed={completed}
                icon={icon}
            />;
}

export default AnimatedStepIcon;